<div class="gamejr-container">
  <div class="header">
    <h4>Game Favorite</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeForm()">
      <img src="assets/icons/icon-close.svg" alt="" />
    </button>
  </div>

  <div class="gamejr-content">
    <p>Designate this spot as a personal favorite &mdash; special moments, hidden treasures, and strategic landmarks across the realm.</p>
  </div>

  <form [formGroup]="categoryForm" (ngSubmit)="handleSubmit()">
    <div class="add-gtop">
      <label class="form-label" for="category-title">Category Title</label>
      <input type="text" id="category-title" class="form-control" formControlName="category" />
    </div>

    <div class="add-gtop">
      <label class="form-label" for="category-color">Category Color</label>
      <input type="color" id="category-color" formControlName="color" class="color-input" />
    </div>

    <div class="add-gtop">
      <label class="form-label" for="location-details">Location Details</label>
      <textarea id="location-details" formControlName="details"></textarea>
    </div>

    <div class="mapicon-sec">
      <label class="form-label">Map Icon</label>
      <div class="mi-box-wrap">
        @for (icon of iconClassArray; track icon; let i = $index) {
          <button type="button" class="mi-box" [class.mi-box--selected]="icon.isChecked" (click)="selectedIconHandle(i)">
            <img [src]="icon.className" [alt]="icon.iconName">
          </button>
        }
      </div>
    </div>

    <div class="btn-sec">
      <button class="btn btn-theme" type="submit" [disabled]="categoryForm.invalid">Submit</button>
    </div>
  </form>
</div>
